import { useMutation } from '@tanstack/react-query'
import { NoContent } from '@/common/types_and_interfaces.ts'
import { ApiCallResult } from '@/lib/tanstack-utils.types.ts'
import axios from 'axios'
import { parseRequestError } from '@/common/utilities.ts'

export type UpdateNonGradeModifierParams = {
  programId: number
  purseId: number
}

export type UpdateNonGradeModifierPayload = {
  id: number
  base_amount: number
  modifier_type_id: number
  is_active: boolean
}

const updateNonGradeModifier = async (
  params: UpdateNonGradeModifierParams,
  payload: UpdateNonGradeModifierPayload
): Promise<NoContent> => {
  const { programId, purseId } = params
  try {
    await axios.post(
      `/programs/${programId}/purses/${purseId}/settings/non_grade_distribution_modifier`,
      payload
    )
    return null
  } catch (e) {
    throw parseRequestError(e)
  }
}

type RequestPayload = {
  params: UpdateNonGradeModifierParams
  payload: UpdateNonGradeModifierPayload
}

export const useUpdateNonGradeModifier = (): ApiCallResult<
  NoContent,
  RequestPayload
> => {
  return useMutation({
    mutationFn: async ({ params, payload }: RequestPayload) => {
      return await updateNonGradeModifier(params, payload)
    },
  })
}
